import { css } from 'lit';

import color from '../../utils/get-color-token';
import { typography } from '../../styles';

export function styles() {
	return css`
		:host {
			${typography('body-md-bold')};
			color: ${color('color-text-secondary')};
		}
	`;
}
